var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBankLine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.66602 26.6667H29.3327V29.3334H2.66602V26.6667ZM5.33268 16H7.99935V25.3334H5.33268V16ZM11.9993 16H14.666V25.3334H11.9993V16ZM17.3327 16H19.9993V25.3334H17.3327V16ZM23.9993 16H26.666V25.3334H23.9993V16ZM2.66602 9.33335L15.9993 2.66669L29.3327 9.33335V14.6667H2.66602V9.33335ZM5.33268 10.9814V12H26.666V10.9814L15.9993 5.64802L5.33268 10.9814ZM15.9993 10.6667C15.6457 10.6667 15.3066 10.5262 15.0565 10.2762C14.8065 10.0261 14.666 9.68698 14.666 9.33335C14.666 8.97973 14.8065 8.64059 15.0565 8.39055C15.3066 8.1405 15.6457 8.00002 15.9993 8.00002C16.353 8.00002 16.6921 8.1405 16.9422 8.39055C17.1922 8.64059 17.3327 8.97973 17.3327 9.33335C17.3327 9.68698 17.1922 10.0261 16.9422 10.2762C16.6921 10.5262 16.353 10.6667 15.9993 10.6667Z",
    fill: "black",
    fillOpacity: 0.6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBankLine);
export default __webpack_public_path__ + "static/media/bank-line.ddd12ad179be225299e941d56510bc0e.svg";
export { ForwardRef as ReactComponent };